export default __webpack_public_path__ + "static/media/9.ad4a2aeb.jpg";